import { render, staticRenderFns } from "./MBControlView.vue?vue&type=template&id=a0dc0802&scoped=true&class=fill-height"
import script from "./MBControlView.vue?vue&type=script&lang=ts"
export * from "./MBControlView.vue?vue&type=script&lang=ts"
import style0 from "./MBControlView.vue?vue&type=style&index=0&id=a0dc0802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dc0802",
  null
  
)

export default component.exports